<template>
  <g>
    <g transform="scale(0.6)">
      <text transform="matrix(1 0 0 1 110 10)" :class="{'hide': !icon}" style="font-size: 26px; fill: red;">압력값: {{pressure}}</text>
      <text transform="matrix(1 0 0 1 130 40)" class="name">압력센서{{number}}</text>
      <path class="st0" d="M186.5,675c-4.14,0-7.5-3.36-7.5-7.5V630h-16v37.5c0,4.14-3.36,7.5-7.5,7.5s-7.5-3.36-7.5-7.5V630h-17.21V259.5
        h0.13v-17.57c-33.86-15.85-55.63-49.95-55.63-87.43c0-53.21,43.29-96.5,96.5-96.5s96.5,43.29,96.5,96.5
        c0,37.36-21.67,71.42-55.38,87.32v23.68h-0.13V630H194v37.5C194,671.64,190.64,675,186.5,675z"/>
      <g>
        <g id="pressure">
          <path class="st1" d="M209.92,239.9c32.63-14.59,55.37-47.34,55.37-85.4c0-51.64-41.86-93.5-93.5-93.5s-93.5,41.86-93.5,93.5
            c0,38.16,22.86,70.97,55.63,85.5v22.5h76V239.9z"/>
        </g>
        <rect x="133.79" y="262.5" class="st2" width="76" height="318.5"/>
        <rect x="133.79" y="581" class="st3" width="76" height="46"/>
      </g>
      <path class="st4" d="M163,80.49"/>
      <g>
        <polygon class="st5" points="163,605.5 149.5,605.5 149.5,225.5 163,228.5"/>
        <polygon class="st5" points="194,605.5 180.5,605.5 180.5,228.5 194,225.5"/>
        <g>
          <defs>
            <path id="SVGID_1_Force" d="M193,83.11c30.73,9.19,53.12,37.67,53.12,71.39c0,41.15-33.35,74.5-74.5,74.5s-74.5-33.35-74.5-74.5
              c0-33.45,22.04-61.75,52.4-71.17"/>
          </defs>
          <clipPath id="SVGID_2_Force">
            <use xlink:href="#SVGID_1_Force"  style="overflow:visible;"/>
          </clipPath>
          <g class="st6">
            <line class="st7" x1="62.5" y1="91.5" x2="295.5" y2="91.5"/>
            <line class="st7" x1="63" y1="95.5" x2="296" y2="95.5"/>
            <line class="st7" x1="63.5" y1="99.5" x2="296.5" y2="99.5"/>
            <line class="st7" x1="64" y1="103.5" x2="297" y2="103.5"/>
            <line class="st7" x1="64.5" y1="107.5" x2="297.5" y2="107.5"/>
            <line class="st7" x1="65" y1="111.5" x2="298" y2="111.5"/>
            <line class="st7" x1="65.5" y1="115.5" x2="298.5" y2="115.5"/>
            <line class="st7" x1="66" y1="119.5" x2="299" y2="119.5"/>
            <line class="st7" x1="66.5" y1="123.5" x2="299.5" y2="123.5"/>
            <line class="st7" x1="67" y1="127.5" x2="300" y2="127.5"/>
            <line class="st7" x1="67.5" y1="131.5" x2="300.5" y2="131.5"/>
            <line class="st7" x1="68" y1="135.5" x2="301" y2="135.5"/>
            <line class="st7" x1="68.5" y1="139.5" x2="301.5" y2="139.5"/>
            <line class="st7" x1="69" y1="143.5" x2="302" y2="143.5"/>
            <line class="st7" x1="69.5" y1="147.5" x2="302.5" y2="147.5"/>
            <line class="st7" x1="70" y1="151.5" x2="303" y2="151.5"/>
            <line class="st7" x1="70.5" y1="155.5" x2="303.5" y2="155.5"/>
            <line class="st7" x1="71" y1="159.5" x2="304" y2="159.5"/>
            <line class="st7" x1="71.5" y1="163.5" x2="304.5" y2="163.5"/>
            <line class="st7" x1="72" y1="167.5" x2="305" y2="167.5"/>
            <line class="st7" x1="72.5" y1="171.5" x2="305.5" y2="171.5"/>
            <line class="st7" x1="73" y1="175.5" x2="306" y2="175.5"/>
            <line class="st7" x1="73.5" y1="179.5" x2="306.5" y2="179.5"/>
            <line class="st7" x1="74" y1="183.5" x2="307" y2="183.5"/>
            <line class="st7" x1="74.5" y1="187.5" x2="307.5" y2="187.5"/>
            <line class="st7" x1="75" y1="191.5" x2="308" y2="191.5"/>
            <line class="st7" x1="75.5" y1="195.5" x2="308.5" y2="195.5"/>
            <line class="st7" x1="76" y1="199.5" x2="309" y2="199.5"/>
            <line class="st7" x1="76.5" y1="203.5" x2="309.5" y2="203.5"/>
            <line class="st7" x1="77" y1="207.5" x2="310" y2="207.5"/>
            <line class="st7" x1="77.5" y1="211.5" x2="310.5" y2="211.5"/>
            <line class="st7" x1="78" y1="215.5" x2="311" y2="215.5"/>
            <line class="st7" x1="78.5" y1="219.5" x2="311.5" y2="219.5"/>
            <line class="st7" x1="79" y1="223.5" x2="312" y2="223.5"/>
          </g>
        </g>
        <path class="st4" d="M193,83.11c30.73,9.19,53.12,37.67,53.12,71.39c0,41.15-33.35,74.5-74.5,74.5s-74.5-33.35-74.5-74.5
          c0-33.45,22.04-61.75,52.4-71.17"/>
      </g>
      <rect x="144.98" y="590" class="st8" width="22" height="37"/>
      <rect x="175.98" y="590" class="st8" width="22" height="37"/>
      <g class="pin">
          <path class="st9" d="M151,667.5V627h9v40.5c0,2.49-2.01,4.5-4.5,4.5l0,0C153.01,672,151,669.99,151,667.5z"/>
          <rect :id="`${pincode}PS`" @click="onClick(`${pincode}PS`)" class="pin-cover terminal snap" x="146" y="665" width="20" height="20"/>
      </g>
      <g class="pin">
          <path class="st9" d="M182,667.5V627h9v40.5c0,2.49-2.01,4.5-4.5,4.5l0,0C184.01,672,182,669.99,182,667.5z"/>
          <rect :id="`${pincode}MS`" @click="onClick(`${pincode}MS`)" class="pin-cover terminal snap" x="175" y="665" width="20" height="20"/>
      </g>
      <!-- <g id="pressure-hand"> -->
      <g id="pressure-hand" :class="{'hide': !icon}">
        <path style="transform: scale(0.17)" d="M925.9,538.3c-31.9-31.9-78.9-34.8-110.8-2.9l-91.2,91.1c-23.7,23.7-52.3,23.7-69,4c-11.1-13.1-6.7-53.3-3.6-78.9L697,175.8c4.1-33.6-19.8-66-53.4-70.1c-33.6-4.1-64.1,21.7-68.2,55.3l-50.4,295.3c-2.6,7.3-8.3,8.6-8.9-1.3L498.8,71.3c0-33.8-27.4-61.3-61.3-61.3c-33.8,0-61.3,27.4-61.3,61.3L375,457.9c0.3,4.5-3.5,5.7-4.2,0.6l-54.5-301.8c-6-33.3-37.9-57.3-71.2-51.3c-33.3,6-55.4,39.8-49.4,73.1l48.5,353.2c0,6.3-2.1,9.9-5,1.8l-72.4-193.6c-11.3-31.9-46.4-50.5-78.3-39.1c-31.9,11.3-48.6,48.3-37.2,80.1l127,414.8c0.7,2.3,1.4,4.6,2.1,6.8l0.3,0.9c0,0.1,0.1,0.1,0.1,0.2C215.8,911.8,317.5,990,437.5,990c76.8,0,156.6-27.1,217.3-73.7l0,0c65.6-39.5,275.8-265.4,275.8-265.4C962.5,619,957.8,570.2,925.9,538.3L925.9,538.3z"/>
      </g>
    </g>
  </g>
</template>

<script>
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

export default {
  props: ['data'],
  mixins: [pins],
  name: 'ForceSensor',
  data () {
    return {
      on: false,
      socket: null,
      pressure: 0,
      icon: false,
      draggable: null
    }
  },
  mounted () {
    this.setPindata(this.data)
  },
  methods: {
    onClick (pin) {
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    },
    press () {
      window.Draggable.get(`#${this.data.id}`).disable()
      if (this.on) {
        if (!this.draggable) this.initDraggable()
      } else {
        window.Draggable.get(`#${this.data.id}`).enable()
      }
    },
    hitDetection () {
      const id1 = `#${this.data.id} #pressure`
      const id2 = `#${this.data.id} #pressure-hand`
      if (window.Draggable.hitTest(id1, id2, '70%')) {
        if (this.pressure < 1024) this.pressure += 16
      } else {
        this.pressure = 0
      }
      this.$store.commit('socket/sendMessage', { socket: this.socket, message: { value: this.pressure } })
    },
    initDraggable () {
      this.draggable = window.Draggable.create(`#${this.data.id} #pressure-hand`, {
        bounds: '#canvas',
        onDrag: () => this.hitDetection()
      })
    },
    start (socket) {
      console.log('Force Sensor Socket is Opened')
      this.socket = socket
      this.on = true
      this.icon = true
      this.pressure = 0
      this.press()
    },
    off () {
      this.socket = null
      this.on = false
      this.icon = false
      this.pressure = 0
      window.Draggable.get(`#${this.data.id}`).enable()
    }
  }
}
</script>

<style lang="scss" scoped>
.pin-cover{
  display: block;
  stroke: none;
  fill: none;
}
.pin:hover{
  cursor: pointer;
  .pin-cover{
    stroke-width: 3px;
    stroke: black;
    fill: #ff6f61;
 }
}
.selected{
  & path.st0{
    display: block;
    fill: #ff6f61;
  }
}
.hide{display: none;}
.name{font-size: 23px}
.st0{fill:#D6D6D6; display: none;}
.st1{fill:#302F36;}
.st2{fill:#A9EECB;}
.st3{fill:#FFFFFF;}
.st4{fill:none;stroke:#A9AA87;stroke-width:5;stroke-miterlimit:10;}
.st5{fill:#A9AA87;}
.st6{clip-path:url(#SVGID_2_Force);}
.st7{fill:none;stroke:#A9AA87;stroke-miterlimit:10;}
.st8{fill:#D7AE65;}
.st9{fill:#808080;}
</style>
